import * as React from 'react';
import { Grid, Typography, Divider, FormControlLabel, Checkbox } from '@material-ui/core';
import ConfirmButton from '../../../../ui-components/Button/ConfirmButton';
import UndoButton from '../../../../ui-components/Button/UndoButton';
import DatePicker from '../../../../ui-components/DatePicker/DatePicker';
import { DayRow } from './DayRow';
import { ActivityDefinitionDay, ActivityDefinition, ActivitySchedule, days, day, ActivityScheduleDefinition, ActivityState } from '../../../../model/activities';
import TextField from '../../../../ui-components/TextField/TextField';
import { Select, SelectItem } from '../../../../ui-components/select/Select';
import { tag } from '../../../../model/tag';
import { addDays, getDay, getDayProp } from '../dateUtils'
import { trainer } from '../../../../model/trainer';
import NewItemButton from '../../../../ui-components/Button/NewItemButton';
import { TrainerDisplay } from '../TrainerDisplay';
interface IProps {
    onCancel: () => any;
    classes: any;
    tags: tag[];
    saveSchedule: (definition: ActivityDefinition, schedules: ActivitySchedule[]) => any;
    trainers: trainer[];
}
export const NewActivityDefinition = (props: IProps) => {
    const { classes, tags } = props;
    const [tag, setTag] = React.useState<tag>();
    const [description, setDescription] = React.useState<string>();
    const [displayName, setDisplayName] = React.useState<string>();
    const [reservable, setReservable] = React.useState<boolean>(true);
    const [from, setFrom] = React.useState<Date>(new Date());
    const [to, setTo] = React.useState<Date>(addDays(new Date(), 1));
    const [selectedDays, setSelectedDays] = React.useState<Array<ActivityDefinitionDay>>([]);
    const [selectedTrainers, setSelectedTrainers] = React.useState<trainer[]>([]);
    const [selectedTrainer, setSelectedTrainer] = React.useState<SelectItem>();
    const saveEnabled = () => {
        let ret = Boolean(description);
        ret = ret && Boolean(from)
        ret = ret && Boolean(to)
        ret = ret && Boolean(selectedDays && selectedDays.length)
        if (ret) {
            if (selectedDays.find(d => !Boolean(d.duration) || !Boolean(d.startTime)))
                ret = false;
            if (ret && reservable)
                if (selectedDays.find(d => !Boolean(d.capacity)))
                    ret = false;
        }
        return ret;
    }
    const confirm = () => {
        var dt = from;
        var daysToConsider = selectedDays.map(d => getDay(d.name) as number);
        const schedules: Array<ActivitySchedule> = [];
        let daysScheduleDefinition: ActivityScheduleDefinition = {};
        selectedDays.forEach(d => {
            daysScheduleDefinition[getDayProp(d.name)] = {
                time: d.startTime,
                duration: d.duration,
                capacity: d.capacity
            };
        });
        while (dt < to) {
            const dayNumber = dt.getDay();
            if (daysToConsider.indexOf(dayNumber) > -1) {
                const dayName = days.find(a => a.code === dayNumber);
                const dDef = selectedDays.find(a => a.name === dayName.name);
                if (dDef) {

                    dt.setHours(dDef.startTime.hours);
                    dt.setMinutes(dDef.startTime.minutes);
                    dt.setSeconds(0);
                    schedules.push({
                        capacity: dDef.capacity,
                        date: dt,
                        displayName: displayName,
                        description: description,
                        duration: dDef.duration,
                        tag: tag,
                        isReservable: reservable,
                        state: ActivityState.draft,
                        trainerIds: (selectedTrainers || []).map(t => t._id)
                    });
                }
            }
            dt = addDays(dt, 1);
        }
        if (schedules && schedules.length) {
            const activityDefinition: ActivityDefinition = {
                scheduleDefinition: daysScheduleDefinition,
                description: description,
                displayName: displayName,
                validFrom: from,
                expiresOn: to,
                isReservable: reservable,
                tag: tag,
                state: ActivityState.draft,
                trainerIds: (selectedTrainers || []).map(t => t._id)
            }
            props.saveSchedule(activityDefinition, schedules);
        }
    }
    const toggleSelect = (val: boolean, d: day) => {
        const idx = selectedDays.findIndex(a => a.name === d.name);
        if (val) {
            if (idx === -1)
                setSelectedDays([...selectedDays, { name: d.name }]);
        }
        else {

            if (idx > -1) {
                selectedDays.splice(idx, 1);
                setSelectedDays([...selectedDays]);
            }
        }
    }
    const setDay = (day: ActivityDefinitionDay) => {
        const idx = selectedDays.findIndex(a => a.name === day.name);
        if (idx > -1) {
            selectedDays.splice(idx, 1, day);
            setSelectedDays([...selectedDays]);
        }
    }
    const addTrainer = () => {
        const toAdd = selectedTrainer;
        if (selectedTrainer && selectedTrainers.findIndex(a => a._id === toAdd.value) === -1) {
            setSelectedTrainers([...selectedTrainers, props.trainers.find(a => a._id === toAdd.value)]);
        }
    }
    const removeTrainer = (id:string) => {
        var toRemove = selectedTrainers.findIndex(a=>a._id === id);
        if (toRemove > -1)
        {
            selectedTrainers.splice(toRemove, 1);
            setSelectedTrainers([...selectedTrainers]);
        }
    }

    const availableTrainers = () => {
        const ret = [];
        (props.trainers || []).forEach(a => {
            if (selectedTrainers && selectedTrainers.findIndex(t => t._id === a._id) === -1)
                ret.push({ name: a.name, value: a._id });
        });
        return ret;
    }
    return (<div className={classes.newActivityPopupContainer}>
        <Grid container style={{ padding: 40, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Grid item sm={12} style={{ display: 'flex', justifyContent: 'center' }}>
                <Typography variant='h6'>Aggiungi un' attività</Typography>
            </Grid>
            <Grid item sm={12} className={props.classes.newActivityDatesContainer}>
                <Grid item sm={12} className={props.classes.newActivityDate}>
                    <TextField value={description} onChange={setDescription} label='Descrizione' />
                </Grid>
                <Grid item sm={6} className={props.classes.newActivityDate}>
                    <TextField value={displayName} onChange={setDisplayName} label='Nome visualizzato' />
                </Grid>
                <Grid item sm={6} className={props.classes.newActivityDate}>
                    <Select fullWidth selected={tag ? { name: tag.description, value: tag.code } : undefined} items={tags.map(t => { return { name: t.description, value: t.code } })} onChange={(item) => setTag(tags.find(t => t.code === item.value))} label='Tag' />
                </Grid>
            </Grid>
            <Grid item sm={12} className={props.classes.newActivityDatesContainer}>
                <Grid item sm={6} className={props.classes.newActivityDate}>
                    <DatePicker
                        key={`newActivityDefinition-from-date-picker`}
                        label="Data inizio validità"
                        fullWidth
                        value={from}
                        onChange={setFrom}
                    />
                </Grid>
                <Grid item sm={6} className={props.classes.newActivityDate}>
                    <DatePicker
                        key={`newActivityDefinition-from-date-picker`}
                        label="Data fine validità"
                        fullWidth
                        value={to}
                        minDate={addDays(from, 1)}
                        onChange={setTo}
                    />
                </Grid>
            </Grid>
            {days.map(n => <DayRow classes={props.classes}
                day={n}
                selected={Boolean(selectedDays.find(a => a.name === n.name))}
                onToggle={(val) => toggleSelect(val, n)}
                value={selectedDays.find(a => a.name === n.name)}
                onchange={setDay}
            />)}


        </Grid>
        <Grid container className={props.classes.trainersContainer}>
            <Grid item sm={4} className={props.classes.newActivityCheckBoxPrenotabile}>
                <FormControlLabel className={props.classes.newActivityCheckBoxLabel}
                    control={<Checkbox checked={reservable} onChange={(e, val) => setReservable(val)} />}
                    label={'Prenotabile'}
                />
            </Grid>
            <Grid item sm={6}>
                <Select fullWidth label={'Istruttore'} selected={selectedTrainer} items={availableTrainers()} onChange={(i) => { setSelectedTrainer(i) }} />
            </Grid>
            <Grid item sm={2} className={props.classes.trainersButton}>
                <NewItemButton text='Aggiungi' onClick={addTrainer} disabled={!selectedTrainer} />
            </Grid>
            <Grid item sm={4}>
            </Grid>
            <Grid item sm={6}>
                {selectedTrainers.map(t => {
                    return <TrainerDisplay trainer={t} removeTrainer={removeTrainer}/>
                })}
            </Grid>
        </Grid>
        <Divider style={{ marginTop: 20, marginBottom: 20 }} />
        <Grid item sm={12} className={props.classes.buttonsContainer}>
            <ConfirmButton text='Conferma' onClick={confirm} disabled={!saveEnabled()} />
            <UndoButton text='Annulla' onClick={() => props.onCancel()} />
        </Grid>
    </div >)
}
